import { jsx, css } from '@emotion/react';
import { define, ui } from '@owenscorning/pcb.alpha';

import Renderer from '../../../../OC/PageBuilder/RainbarrierComparisonTable.jsx';

export default define`Rainbarrier Comparison Table`('0.0.1')({
  thumbnail: ui`Modules/Page/Thumbnails/RainbarrierComparisonTable`,
  category: ui`Modules/Categories/Page/Prebuilt`,
  view: ({ value }) => <Renderer {...value} />,
  edit: {},
});
